export default __webpack_public_path__ + "static/media/23.8034e3ab.png";